import { InjectionToken, NgModule } from '@angular/core';
import { REPORTING_CONFIG_TOKEN, ReportingConfig } from './tokens-and-interfaces';

@NgModule({
  imports: [],
})
export class ReportingCoreModule {
  static forRoot(c: { config: InjectionToken<ReportingConfig> }) {
    return {
      ngModule: ReportingCoreModule,
      providers: [{ provide: REPORTING_CONFIG_TOKEN, useExisting: c.config }],
    };
  }
}
